// YNX — MASTER ADMIN Diagnostics API client
const API = process.env.REACT_APP_BACKEND_URL;

const h = (secret) => ({
  'Content-Type': 'application/json',
  'X-YNX-Owner-Secret': secret,
});

const json = async (res) => {
  if (!res.ok) {
    let err = `HTTP ${res.status}`;
    // Best-effort: keep HTTP status if the body isn't JSON.
    try { const j = await res.json(); err = j.detail || err; }
    catch (parseErr) { console.debug('YNX diag: error body not JSON', parseErr); }
    throw new Error(err);
  }
  return res.json();
};

export const diagListErrors = (secret, { limit = 100, skip = 0, source = '', severity = '' } = {}) => {
  const p = new URLSearchParams();
  p.set('limit', String(limit)); p.set('skip', String(skip));
  if (source) p.set('source', source);
  if (severity) p.set('severity', severity);
  return fetch(`${API}/api/biz/admin/diagnostics/errors?${p.toString()}`, { headers: h(secret) }).then(json);
};

export const diagStats = (secret) =>
  fetch(`${API}/api/biz/admin/diagnostics/stats`, { headers: h(secret) }).then(json);

export const diagGenerateReport = (secret) =>
  fetch(`${API}/api/biz/admin/diagnostics/weekly-report`, { method: 'POST', headers: h(secret) }).then(json);

export const diagLatestReport = (secret) =>
  fetch(`${API}/api/biz/admin/diagnostics/latest-report`, { headers: h(secret) }).then(json);

export const diagListReports = (secret, limit = 10) =>
  fetch(`${API}/api/biz/admin/diagnostics/reports?limit=${limit}`, { headers: h(secret) }).then(json);

export const diagClearErrors = (secret, olderThanDays = 0) =>
  fetch(`${API}/api/biz/admin/diagnostics/errors?older_than_days=${olderThanDays}`, {
    method: 'DELETE', headers: h(secret),
  }).then(json);

export const diagEnsureIndexes = (secret) =>
  fetch(`${API}/api/biz/admin/diagnostics/_ensure_indexes`, { method: 'POST', headers: h(secret) }).then(json).catch(() => null);
